import React from 'react';
import { NodesContext } from "../context";
export var useNodesContext = function useNodesContext() {
  var nodesContext = React.useContext(NodesContext);
  if (nodesContext === null) {
    throw Error('Attempting to use NodesContext before providing essential data via NodesProvider');
  }
  return nodesContext;
};